export default "__VITE_ASSET__ComM9Nby__"